module.exports = __webpack_public_path__ + "static/Bullet-e8217c7ecef2822ff7ab9269ae6bb450.png";